import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=7d6cc46d&scoped=true&"
import script from "./NotificationTable.vue?vue&type=script&lang=js&"
export * from "./NotificationTable.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTable.vue?vue&type=style&index=0&id=7d6cc46d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6cc46d",
  null
  
)

export default component.exports